import { LegalPage } from '../components/Legal/LegalPage';

export const PrivacyPolicyPage = () => {
  return <LegalPage title="Privacy Policy" filename="privacy-policy.md" />;
};